<template>
  <div class="mainNavWrap">
    <div class="mainNav">
      <ul>
        <li v-for="(nav, index) in headnavs" :key="index">        
          <span class="nav_item" @click="updateActiveMenu(nav.name)" :class="{ 'active': activeMenu(nav.name) }">{{nav.title}}</span>         
        </li>       
        <!-- <li>
          <router-link
            to="/main/community/free"
            :class="{ 'router-link-active': subIsActive('/main/community') }"
          >
            <span @click="updateActiveMenu('community')">커뮤니티</span>
          </router-link>
        </li> -->
      </ul>
      <div class="navSpread">
          <span @click="shownav=!shownav">
              <span v-if="shownav"><span style="font-size:20px"><font-awesome-icon icon="times"/></span></span>
              <span v-else>전체보기 <span style="font-size:20px"><font-awesome-icon icon="bars"/></span></span>
          </span>
      </div>
    </div>   
    <menu-login/>
  </div>
  <nav-open :show="shownav"  @close="hidenav" :pos_top="pos_top" />
</template>
<script>
import MenuLogin from '@/components/site/MenuLogin';
import NavOpen from '@/components/site/spreadNav/NavOpen';
import { updateMenu } from '@/utils/menu.js'
export default {
  props:[
    'pos_top' 
  ]
  ,
  data(){
    return{
      shownav:false,
      headnavs:''  
    }
  },
  components:{
      MenuLogin,
      NavOpen
  },
  created() {
        this.headnavs = this.$store.state.menu.menus
  },  
  methods: {
    activeMenu(input){
      return input === this.$store.state.menu.activeMenu;
    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
        //:active="$route.name.match('라우트이름*')"
      });
    },
    updateActiveMenu(menu) {     
      updateMenu(menu,'all', this.$store);
      this.$router.push({
        path: "/main/community/" + menu +"/all"
      });
      //this.$store.commit('menu/setActiveDocument', 'free');
    },   
    hidenav(){      
      this.shownav=false;   
    },
     async getList(){
      const formData = {
        document: 'all',
        menu:this.getMenu,
        page:1
      }      
      try{
        const response = await this.$store.dispatch("posts/fetchLists", formData);
        console.log('게시글리스트업', response);        
      }catch(error){
        console.log('리스트업 에러', error)
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.mainNavWrap{
    width:100%;
    display: flex;
    justify-content: space-between;
    .mainNav{
        display:flex;
        align-items: center;
        justify-content: space-between;
        .navSpread{
          cursor:pointer;
        }
        li{
          cursor:pointer
        }
    }
    
}
</style>
